//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ZoomImage',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    fallbackSrc: {
      type: String,
      default: ''
    },
    allowZoom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: true,
      openZoom: false
    };
  },
  methods: {
    handleImageClick() {
      this.openZoom = this.valid && this.allowZoom;
      this.$emit('zooming', this.openZoom);
    },
    handleCloseZoom() {
      this.openZoom = false;
      this.$emit('zooming', false);
    },
    handleInvalidImage() {
      this.openZoom = false;
      this.valid = false;
      this.$emit('invalid');
    }
  }
};
